import React from 'react'
import WeeklyCompareChart from './weeklyCompareChart/weeklyCompareChart'

const WeeklyCompareCard = () => {
    return (
        <div className='w-full h-fit text-sm font-color-4 flex flex-col'>
            <div className='flex justify-between items-center'>
                <p>Projektaktivität</p>
                <button
                    className='hidden ml-4 px-3 py-2 bg-color-5 font-color-1 text-sm flex items-center shadow-sm border border-color-2 rounded-lg font-medium'>
                    Report anzeigen
                </button>
            </div>
            <div className='flex items-center'>
                <div className='font-color-6 mt-2'>Projektaktivität der letzten 12 Wochen</div>
            </div>
            <div className='flex justify-center items-center w-full h-36 my-4'>
                <WeeklyCompareChart/>
            </div>
            <div className='flex justify-center items-center gap-2 mt-2'>
                <div className='w-2 h-2 bg-color-1 rounded-full'/>
                <div className='font-color-6'>Letzten 6 Wochen</div>
                <div className='ml-2 w-2 h-2 bg-color-4 rounded-full'/>
                <div className='font-color-6'>6-12 Wochen zuvor</div>
            </div>
        </div>
    )
}

export default WeeklyCompareCard